import { callable } from './functions';

export interface ConnectInvoiceNinjaInput {
  orgId: string;
  baseUrl: string;
  token: string;
  secret?: string;
}

export const connectInvoiceNinja = callable<ConnectInvoiceNinjaInput, { companyName: string }>(
  'connectInvoiceNinja',
);

export const importInvoiceNinjaClients = callable<
  { orgId: string },
  { imported: number; updated: number; total: number }
>('importInvoiceNinjaClients');

export const pushClientToInvoiceNinja = callable<
  { orgId: string; clientId: string },
  { invoiceNinjaClientId: string }
>('pushClientToInvoiceNinja');

export const importInvoiceNinjaItems = callable<
  { orgId: string },
  { imported: number; updated: number; total: number }
>('importInvoiceNinjaItems');

export const createInvoiceNinjaInvoice = callable<
  { orgId: string; gigId: string; quoteId: string },
  { invoiceNinjaId: string; url: string }
>('createInvoiceNinjaInvoice');

export const refreshInvoiceNinjaInvoiceStatus = callable<
  { orgId: string; gigId: string },
  { balance: number; paidToDate: number; fullyPaid: boolean; status: string | null }
>('refreshInvoiceNinjaInvoiceStatus');
